import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Phone, MessageCircle } from "lucide-react";
import { BRAND, WHATSAPP_URL, TEL_URL } from "../../lib/site-data";
import { Button } from "../ui/button";

const NAV = [
    { to: "/pico-lazer-dovme-silme", label: "Pico Lazer" },
    { to: "/fraksiyonel-co2-lazer", label: "Fraksiyonel CO2" },
    { to: "/dovme-silme-fiyatlari", label: "Fiyat Bilgisi" },
    { to: "/blog", label: "Blog" },
    { to: "/iletisim", label: "İletişim" },
];

export default function Header() {
    const [open, setOpen] = useState(false);

    return (
        <header
            className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/5"
            data-testid="site-header"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="flex items-center justify-between h-16 md:h-20">
                    <Link to="/" className="flex flex-col leading-none" data-testid="brand-link">
                        <span className="font-display text-base md:text-lg font-medium tracking-tight text-white">
                            {BRAND.name}
                        </span>
                        <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-cyan-300/80">
                            {BRAND.owner}
                        </span>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-8">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                className={({ isActive }) =>
                                    `text-sm tracking-wide transition-colors ${
                                        isActive
                                            ? "text-cyan-300"
                                            : "text-zinc-300 hover:text-white"
                                    }`
                                }
                                data-testid={`nav-${item.to.replace(/\//g, "")}`}
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </nav>

                    <div className="flex items-center gap-2">
                        <a
                            href={TEL_URL}
                            className="hidden md:inline-flex items-center gap-2 text-xs text-zinc-300 hover:text-cyan-300 transition-colors"
                            data-testid="header-phone"
                        >
                            <Phone className="h-3.5 w-3.5" />
                            {BRAND.phone}
                        </a>
                        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="header-whatsapp-cta">
                            <Button
                                size="sm"
                                className="bg-transparent border border-cyan-400/60 text-cyan-300 hover:bg-cyan-400 hover:text-black transition-all duration-300 shadow-[0_0_15px_rgba(0,240,255,0.15)] hover:shadow-[0_0_25px_rgba(0,240,255,0.4)]"
                            >
                                <MessageCircle className="h-4 w-4 mr-1.5" />
                                WhatsApp
                            </Button>
                        </a>
                        <button
                            className="lg:hidden text-white p-2"
                            onClick={() => setOpen((s) => !s)}
                            aria-label="Menü"
                            data-testid="mobile-menu-toggle"
                        >
                            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>
                    </div>
                </div>

                {open && (
                    <div className="lg:hidden pb-6 pt-2 space-y-3 animate-slide-in" data-testid="mobile-nav">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                onClick={() => setOpen(false)}
                                className={({ isActive }) =>
                                    `block py-2 text-base ${
                                        isActive
                                            ? "text-cyan-300"
                                            : "text-zinc-200"
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                        <a
                            href={TEL_URL}
                            className="block py-2 text-zinc-300 text-sm"
                        >
                            {BRAND.phone}
                        </a>
                    </div>
                )}
            </div>
        </header>
    );
}
